import * as Axios from "./axios.service";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getTenantFeature(tenantId, featureId) {
    return Axios.post(
      "/api/feature/tenant",
      {
        tenantId: tenantId,
        featureId: featureId,
      }
    );
  },
  getTenantModule(tenantId, moduleId) {
    return Axios.post(
      "/api/feature/tenant/module",
      {
        tenantId: tenantId,
        moduleId: moduleId,
      }
    );
  }
};
